import React from "react";
import glamorous, { Div } from "glamorous";
import { css } from "glamor";
import SearchSection from "../../blocks/SearchSection";
import ScrollToTop from "../../common/ScrollToTop";
import { truncate } from "../../../style/index";
import { dimensions } from "../../../style/index";

const Grid = glamorous.div({
  display: "grid",
  gridTemplateColumns: "repeat(2, 500px)",
  gridGap: 24,
  justifyContent: "center",
  paddingTop: 50,
  paddingBottom: 104,
  position: "relative",
  zIndex: 2,
  "@media (max-width: 1090px)": {
    gridTemplateColumns: "repeat(1,500px)"
  },
  [dimensions.SCREEN_MAX_SM]: {
    gridTemplateColumns: "repeat(1, 340px)"
  }
});

const Card = glamorous.div(
  {
    height: 250,
    width: "auto",
    background: "black",
    borderRadius: 8,
    display: "flex",
    flexDirection: "center",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Playfair Display', serif",
    textTransform: "uppercase",
    fontSize: 62,
    cursor: "pointer",
    [dimensions.SCREEN_MAX_SM]: {
      height: 206,
      fontSize: 48
    }
  },
  ({ imageUrl }) => {
    if (imageUrl) {
      return {
        background:
          imageUrl &&
          `linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${imageUrl})`,
        backgroundPosition: "center",
        backgroundSize: "cover"
      };
    }
  }
);

const City = glamorous.p({
  textAlign: "center",
  ...truncate
});

const Gradient = glamorous.div({
  height: 613,
  width: "100%",
  background:
    "linear-gradient(to bottom right, rgba(35,15,54,1) 50%, transparent 50%)",
  position: "absolute",
  top: 0,
  zIndex: 1
});

const renderCards = (destinations, dropInSearchResults) => {
  if (destinations && destinations.length > 0) {
    var destinationsShuffled = destinations.sort(() => 0.5 - Math.random());
    return destinationsShuffled.slice(0, 4).map(({ loc, image }, index) => {
      let { city, country } = loc;

      return (
        // TODO: Use unique key for key
        <Card
          key={`${country}-${index.toString()}`}
          onClick={() => {
            dropInSearchResults(false, loc);
          }}
          imageUrl={image}
        >
          <City>{city ? city : country}</City>
        </Card>
      );
    });
  }
};

const TopDestinations = props => {
  const { destinations, dropInSearchResults } = props;

  return (
    <SearchSection
      title="Top Destinations"
      backgroundColor="#2c193b"
      height={897}
      otherStyles={css({ position: "relative" })}
      titleStyles={css({ position: "relative", zIndex: 2 })}
    >
      <Grid>{renderCards(destinations, dropInSearchResults)}</Grid>
      <Gradient />
      <Div
        background="linear-gradient(transparent 0%, rgba(0,0,0,0.5) 100%)"
        height={184}
        width="100%"
        position="absolute"
        bottom={0}
      />
      <ScrollToTop {...css({ position: "absolute", bottom: 20, right: 10 })} />
    </SearchSection>
  );
};

export default TopDestinations;



// WEBPACK FOOTER //
// ./src/components/pages/Search/TopDestinations.jsx